/**
 * 美国地址格式：门牌号, 街道, 城市, 州, 邮编, 国家
 */
export function formatUsAddress(houseNumber, street, city, state, zip, country) {
  const parts = []
  if (houseNumber && street) {
    parts.push(`${houseNumber} ${street}`)
  } else if (street) {
    parts.push(street)
  } else if (houseNumber) {
    parts.push(houseNumber)
  }
  if (city) parts.push(city)
  if (state) parts.push(state)
  if (zip) parts.push(zip)
  if (country) parts.push(country)
  return parts.join(', ')
}

/**
 * 公司地址分两行：第一行 街道+邮编，第二行 城市+州+国家（同栏过长时由 CSS 内换行）
 */
export function formatCompanyAddressLines(companyAddress, city, state, zip, country) {
  const p1 = [companyAddress, zip].map(s => (s && String(s).trim()) || '').filter(Boolean)
  const p2 = [city, state, country].map(s => (s && String(s).trim()) || '').filter(Boolean)
  return { line1: p1.length ? p1.join(', ') : '', line2: p2.length ? p2.join(', ') : '' }
}
